import Popover, { PopoverProps } from "@mui/material/Popover";

import { useForwardPointerEvents } from "shared/common/hooks/UseForwardPointerEvents";

interface CustomPopoverProps extends PopoverProps {
  onForwardedPointerEvent?: (e: React.PointerEvent) => void;
}

export default function PopoverWithPointerForwarding({
  onForwardedPointerEvent,
  onClose,
  slotProps,
  ...popoverProps
}: CustomPopoverProps) {
  const handlePointerEvent = useForwardPointerEvents(
    onForwardedPointerEvent,
    onClose
  );

  return (
    <Popover
      {...popoverProps}
      onClose={onClose}
      slotProps={{
        ...slotProps,
        root: {
          style: {
            userSelect: "none",
          },
        },
        backdrop: {
          style: { touchAction: "none" },
          onPointerDown: handlePointerEvent,
          onPointerMove: handlePointerEvent,
          onPointerUp: handlePointerEvent,
          onPointerCancel: handlePointerEvent,
          ...(slotProps?.backdrop || {}),
        },
      }}
    >
      {popoverProps.children}
    </Popover>
  );
}
